var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const CheckCircle = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-check_circle ${className}`} {...other}>
      <g>
        <path d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zm3.07 3.946l.353.354a.5.5 0 010 .707L7.236 10.7 4.573 7.99a.5.5 0 01.007-.707l.356-.35a.5.5 0 01.638-.053l.07.059 1.6 1.628 3.118-3.121a.5.5 0 01.707 0z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default CheckCircle;
